/**
 * Resolves a feature flag value for a given account.
 *
 * Reads `account.custom_attributes.feature_flags` and walks the flag key,
 * supporting dotted paths (e.g. `explo.reports_dashboard`) so a nested flag
 * resolves through each segment. Returns `true` only when the resolved value
 * is strictly `true`.
 *
 * Shared by the `isNewFeatureFlagEnabled` getter (current account) and the
 * Improvement Center route guard (route target account). Only the value
 * extraction is shared — the account selection stays with each caller.
 *
 * @param {object} account account object (may be undefined)
 * @param {string} flag feature flag key, dotted paths supported
 * @return {boolean} whether the flag is enabled for the account
 */
export const isFeatureFlagEnabledForAccount = (account, flag) => {
  const featureFlags = account?.custom_attributes?.feature_flags;
  if (!featureFlags || !flag) return false;

  const keys = flag.split('.');

  const value = keys.reduce((accumulator, key) => {
    return accumulator && typeof accumulator === 'object' && key in accumulator
      ? accumulator[key]
      : false;
  }, featureFlags);

  return value === true;
};
